<template>
  <section :class="[ 'rollover-section', section.classes ]" :data-section-index="idx">
    <div :class="[ 'content', { 'fade-in': showContent } ]">
      <div :class="[ 'detail-instructions', { active: showOverlay } ]">
        <p
          class="font-regular text-size-35 fg-white"
          v-html="section.instructions"
        ></p>
        <div class="icon"></div>
      </div>

      <div
        :class="[ 'focusable', 'hover', section.trigger, { active } ]"
        :style="getItemStyle(section)"
        @mousedown.prevent="onPress"
        @touchstart.prevent="onPress"
        @mouseup.prevent="onClick"
        @touchend.prevent="onClick"
      >
        <div class="image-wrapper">
          <img :src="section.source" :alt="section.label" draggable="false">
        </div>
        <div
          :class="[ 'label', section['label-classes'] ]"
        >
          <span v-html="section.label"></span>
          <div class="lines">
            <div class="line line-root node-start">
              <div class="line line-tail node-end"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
  
<script>
export default {
  name: 'RolloverSection',
  components: {},
  props: {
    section: {
      type: Object,
      required: true,
    },
    idx: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
      showContent: false,
      showOverlay: false,

      eventHandlers: {},
    }
  },
  methods: {
    getItemStyle(item) {
      const properties = [ 'top', 'left', 'width', 'height' ];
      let style = '';
      properties.forEach(prop => {
        if (item[prop] !== undefined) {
          style += `${prop}:${item[prop]}rem;`
        }
      });
      return style;
    },

    onAction(event) {
      if (event.type in this.eventHandlers) {
        return this.eventHandlers[event.type](event);
      }
      this.$emit('action', event);
    },
    activateState() {
      this.showContent = true;
      this.showOverlay = true;
    },
    onPress() {
      this.active = true;
    },
    onClick() {
      this.$emit('action', { type: 'next' });
    },
  },
  mounted() {
    if (this.section.chapter !== null) {
      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: this.section.chapter,
          onEnded: () => this.activateState(),
        }
      });
    } else {
      this.activateState();
    }
    this.$emit('action', { type: 'updateHeader', data: this.section['header-color'] });
  },
}
</script>
